var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-1"},[_c('specialsHomeVue')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }